import { config_sentry } from '~/assets/js/plugins/sentry';
import is_dev from '~/assets/js/functions/is_dev';

export default defineNuxtPlugin(nuxtApp => {
  if (is_dev()) return;
  config_sentry(nuxtApp.vueApp, nuxtApp.$router);
});
